'use client'
import { useTranslations } from 'next-intl'
import React, { PropsWithChildren, useCallback, useState } from 'react'
import { LoadingWithContainer } from '../../Loaders'
import LoadMoreButton from '../../LoadMoreButton/loadMoreButton'
import { NoData } from '../Elements'
import styles from '../Elements/styles.module.scss'
import { useBody } from './useBody'

interface MobileDataTableProps {
  lazy?: boolean
  data: any[]
  loading?: boolean
  rowComponent: any
  itemsPerPage?: number
}

const MobileDataTable: React.FC<MobileDataTableProps> = ({
  itemsPerPage = 5,
  lazy = true,
  data,
  loading,
  rowComponent,
}: PropsWithChildren<MobileDataTableProps>) => {
  const [itemsInPage, setItemsInPage] = useState(itemsPerPage)
  const t = useTranslations('translation')

  const loadMoreClick = useCallback(() => {
    setItemsInPage(itemsInPage + itemsInPage)
  }, [itemsInPage])

  const body = useBody({ lazy, data, rowComponent, itemsInPage })

  if (loading !== undefined && loading) {
    return <LoadingWithContainer />
  }

  return (
    <div>
      {data.length === 0 ? <NoData>{t('noData')}</NoData> : body}

      {lazy && data.length > itemsInPage && (
        <div className={styles.loadMoreWrap}>
          <LoadMoreButton onClick={loadMoreClick}>
            {t('loadMore')}
          </LoadMoreButton>
        </div>
      )}
    </div>
  )
}

export default MobileDataTable
